/**
 * 设置运行环境
 * @param {*} params 
 */
 export function setRuntimeEnv(params) {
  const ua = window.navigator.userAgent.toLowerCase()
  // android平台
  window.isAndroid = (() => {
    return /Android|Adr/i.test(ua)
  })()
  // ios平台
  window.isIos = (() => {
    return /iPhone|iPod|iPad/i.test(ua)
  })()
  // 微信小程序
  window.isWxmp = (() => {
    return /miniProgram/i.test(ua) || window.__wxjs_environment === 'miniprogram'
  })()
  // mychevy app
  window.isMychevy = (() => {
    return /MyChevy/i.test(ua)
  })()
  // 微信浏览器
  window.isWeChat = (() => {
    return ua.match(/MicroMessenger/i) == 'micromessenger'
  })()
  // ios版本号
  window.iosVNum = (() => {
    var ver = ua.match(/cpu iphone os (.*?) like mac os/);
    if(ver){
      let num = ver[1].replace(/_/g,".").split(".")[0]
      console.log("你当前的IOS系统版本为：",num);
      return num
    }
  })()
}

/**
 * 获取微信sdk配置中的 url
 */
 export function getConfigUrl() {
  let url
  if (window.__wxjs_is_wkwebview) {
    if (window.initUrl) {
      url = window.initUrl
    } else {
      window.initUrl = location.origin + location.pathname + location.search
    }
    url = window.initUrl
  } else {
    url = location.origin + location.pathname + location.search
  }

  if (url.indexOf('#') >= 0) {
    url = url.split('#')[0]
  }
  return url
}

export function setCookie (name, value){ 
  //name相当于key,value为转入的值
  var expdate = new Date();   //初始化时间
  expdate.setTime(expdate.getTime() + 30 * 60 * 1000);   //时间单位毫秒
  document.cookie = name+"="+value+";expires="+expdate.toGMTString()+";path=/";
}

export function getCookie(c_name) {
  //这里的c_name为setCookie()中name的key值
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1){
          c_start = c_start + c_name.length + 1;
          var c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1)
              c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end));
      }
  }
  return ""
}